import { TextField } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';

interface DefaultTextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const DefaultTextField = ({
  label,
  value,
  onChange,
  placeholder,
}: DefaultTextFieldProps) => {
  const [localValue, setLocalValue] = useState(value);
  const updateTimeoutRef = useRef<NodeJS.Timeout>();
  const localValueRef = useRef(value);
  const latestValuePropRef = useRef(value);

  useEffect(() => {
    localValueRef.current = localValue;
  }, [localValue]);

  useEffect(() => {
    latestValuePropRef.current = value;
    setLocalValue(value);
    localValueRef.current = value;
  }, [value]);

  useEffect(() => {
    return () => {
      if (updateTimeoutRef.current) {
        clearTimeout(updateTimeoutRef.current);
      }
      // Save on unmount using ref to get latest value
      if (localValueRef.current !== latestValuePropRef.current) {
        onChange(localValueRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TextField
      label={label}
      value={localValue}
      onChange={e => {
        const newValue = e.target.value;
        setLocalValue(newValue);

        if (updateTimeoutRef.current) {
          clearTimeout(updateTimeoutRef.current);
        }

        updateTimeoutRef.current = setTimeout(() => {
          onChange(newValue);
        }, 300);
      }}
      onBlur={() => {
        if (updateTimeoutRef.current) {
          clearTimeout(updateTimeoutRef.current);
        }
        if (localValue !== value) {
          onChange(localValue);
        }
      }}
      fullWidth
      variant="outlined"
      size="small"
      placeholder={placeholder}
    />
  );
};
